// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import global components
import DefaultLayout from "../../../global/components/DefaultLayout.js.jsx";

function NotFound({}) {
  return(
    <DefaultLayout>
      <Helmet
        title={"Not Found | Pro-ficiency"}
      />
      <div className="flex column">
        <section className="section white-bg the-404">
          <div className="hero flex three-quarter ">
            <div className="yt-container slim">
              <h1> 404: <span className="light-weight">Page not found</span></h1>
              <hr/>
              <h4><Link to="/" className="action-link">Head back home <i className="ion ion-ios-arrow-right"></i></Link></h4>
            </div>
          </div>
        </section>
      </div>
    </DefaultLayout>
  )
}

export default withRouter(NotFound);



// WEBPACK FOOTER //
// modules/static/views/NotFound.js.jsx